// add custom remove and update functions to cart when init
$(document).on("pageshow", "#cart[data-role='page']", function(event, data) {
    removeitem();
    updatequantity();
   $('#checkoutnowfloat, #checkoutnowfloat2').off('click').on('click', function() {
        $('#cartform #checkoutnow').trigger('click');
});
});


// remove previous cart page when refreshed in the dom
$(document).on("pageshow", "#cart[data-role='page']", function(event, data) {
    // if coming from cart page remove it
    if (jQuery(data.prevPage).attr('id') == 'cart') {
        jQuery(data.prevPage).remove();
        //scroll back to previous position
        $.mobile.silentScroll(window.cartscrolltop);
    }
  
   if (localStorage.getItem('storedDiscount')){  
      var discountStored = localStorage.getItem('storedDiscount');   
      $('input[name="discount"]').val(localStorage.getItem('storedDiscount'));  
    }  
    $('form[action="/cart"]').on('submit', function(){ 
      var $discountCode = $('input[name="discount"]').val(); 
      localStorage.setItem('storedDiscount', $discountCode);  
    });   
  
  
  
 
  
});

// always remove cart from dom
$(document).on("pagehide", "#cart[data-role='page']", function(event, data) {
    $(event.target).remove();
});



function updatequantity() {
    $('.btn-number').unbind().click(function(e) {
        e.preventDefault();




        fieldName = $(this).attr('data-field');
        type = $(this).attr('data-type');
        var input = $(this).closest('.quantity-wrap').find("input[type='number']");
        var currentVal = parseInt(input.val());
        if (!isNaN(currentVal)) {
            if (type == 'minus') {

                if (currentVal > input.attr('min')) {
                    input.val(currentVal - 1).change();
                }
                if (parseInt(input.val()) == input.attr('min')) {
                    $(this).attr('disabled', true);
                }

            } else if (type == 'plus') {
                if (currentVal < input.attr('max')) {
                    input.val(currentVal + 1).change();
                }
                if (parseInt(input.val()) == input.attr('max')) {
                    $(this).attr('disabled', true);
                }

            }
        } else {
            input.val(0);
        }
    });
    $('.input-number').focusin(function() {
        $(this).data('oldValue', $(this).val());
    });
    $('.input-number').change(function() {

        minValue = parseInt($(this).attr('min'));
        maxValue = parseInt($(this).attr('max'));
        valueCurrent = parseInt($(this).val());

        name = $(this).attr('id');
        if (valueCurrent >= minValue) {
            $(".btn-number[data-type='minus'][data-field='" + name + "']").removeAttr('disabled')
        } else {
            alert('Sorry, the minimum value was reached');
            $(this).val($(this).data('oldValue'));
        }
        if (valueCurrent <= maxValue) {
            $(".btn-number[data-type='plus'][data-field='" + name + "']").removeAttr('disabled')
        } else {
            alert('Sorry, the maximum value was reached');
            $(this).val($(this).data('oldValue'));
        }


    });
    $(".input-number").keydown(function(e) {
        // Allow: backspace, delete, tab, escape, enter and .
        if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 190]) !== -1 ||
            // Allow: Ctrl+A
            (e.keyCode == 65 && e.ctrlKey === true) ||
            // Allow: home, end, left, right
            (e.keyCode >= 35 && e.keyCode <= 39)) {
            // let it happen, don't do anything
            return;
        }
        // Ensure that it is a number and stop the keypress
        if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
            e.preventDefault();
        }
    });




    $("#cartform input.quantity").change(function() {

        // get current scroll position 
        window.cartscrolltop = $(window).scrollTop();

        var item_id = $(this).attr('id').replace('updates_', '');
        var item_quantity = $(this).val();
        var updatestring = 'updates[' + item_id + ']=' + item_quantity;
        jQuery.ajax({
            type: 'POST',
            url: '/cart/update.js',
            data: updatestring,
            async: false,
            cache: false,
            dataType: 'json',
            success: function(data) {
                cartcall(data);
            },
            error: Shopify.onError
        });
        setTimeout(function() {
            $.mobile.changePage("/cart", {
                showLoadMsg: true,
                reloadPage: true,
                changeHash: false,
                transition: "none"
            });
        }, 300);
        // add function for updating cart icons
    });

}



function removeitem() {
    $("#cartform .remove").unbind().click(function(e) {
        e.preventDefault();
        var productid = jQuery(this).attr('product-id');


        jQuery.ajax({
            type: 'POST',
            url: '/cart/update.js',
            data: 'updates[' + productid + ']=0',
            async: false,
            cache: false,
            dataType: 'json',
            success: function(data) {
                cartcall(data);
            },
            error: Shopify.onError
        });
        // reload cart page
        jQuery(this).closest('.product-cart-wrap').fadeOut(400, function() {
            $.mobile.changePage("/cart", {
                showLoadMsg: true,
                reloadPage: true,
                transition: "none"
            });
        });
    });
}



function cartcall(data) {
    console.log(data.item_count);
    // refresh cart icons
    jQuery('.cart-count').html(data.item_count);
    // check for hasitem on zero
    if (data.item_count < 1) {
        $('.cart-target').removeClass('hasitem');
    } else {
        $('.cart-target').addClass('hasitem');
    }
}



function myFunction() {
    var x = document.getElementById("top-header");
    if (x.style.display === "none") {
        x.style.display = "block";
    } else {
        x.style.display = "none";
      setTimeout( function() {$( "#header" ).toolbar("updatePagePadding")}, 0);
    }
}

$(document).one("pagecreate", function(event) {
  
  
   if (localStorage.getItem('storedDiscount')){  
   var storedDiscount = localStorage.getItem('storedDiscount');
   if(storedDiscount.includes("PROM")) {
     $('html').addClass('promdiscount'); 
   }
   }

});

jQuery( "#promform" ).submit(function( event ) {

  event.preventDefault();
  
  var discountcode = jQuery('#promform input[name=discount]').val();
  var discountcode = discountcode.toUpperCase();
  
  if(discountcode.includes("PROM")) {

  localStorage.setItem('storedDiscount', discountcode); 
   var discountStored = localStorage.getItem('storedDiscount');  
  
   jQuery('#prom').find('.first').hide(400, function() {
     jQuery(this).siblings('.second').show(400);
    });
  
   jQuery('#top-header').find('.first').hide(0, function() {
     jQuery(this).siblings('.second').show(0);
    });
  
   $('html').addClass('promdiscount'); 
  }else{
   alert('The Discount code you entered might be a regular discount code and not a PROM Specific code. Please enter a PROM specific code');
  }
  
});



function triggerklaviyo() {
    function attachklaviyo(jsonObj) {
        KlaviyoSubscribe.attachToForms('#email_signup', jsonObj );
    }
    // create a JSON object with the success function
     var jsonObj = {
             extra_properties: {
                $source: 'CartPopUp'
            },
            success: function() {
                jQuery('#email_signup').parent('.first').hide(400, function() {
                    jQuery(this).siblings('.second').show(400).closest('.inner').addClass('unlock'), jQuery('#checkoutnowfloat2').addClass('hvr-pulse2');
                });
            } 
    }
     
    // now lets add extra properties 
    jQuery.getJSON('/cart.js', function(cart) {
      var items = cart.items;
      var price= ( cart.original_total_price / 100).toFixedDown(2);
      var discountprice = ( price / 100) * 10;
       console.log('discount price' + discountprice);
      var discountprice = discountprice.toFixedDown(2);
        console.log('discount price' + discountprice);
      var discountprice = price - discountprice;     
      var discountprice = Number(discountprice).toFixed(2);
      var price= price;
      jsonObj.extra_properties['cart_original_price'] = price;
      jsonObj.extra_properties['cart_discount_price'] = discountprice;
      jsonObj.extra_properties['cart_item_count'] = cart.item_count;
      var needle = '//cdn.shopify.com/s/files/1/3099/4602/0720/';
      for (var i = 0, len = items.length; i < len; i++) { 
        var newUser = "product_1" + i;
        var newValue = "value" + i;
        jsonObj.extra_properties['product_variant_id_' + i] = items[i].variant_id ;
        jsonObj.extra_properties['product_title_' + i]=items[i].title;
        jsonObj.extra_properties['product_quantity_' + i]=items[i].quantity;
        jsonObj.extra_properties['product_price_' + i]= ( items[i].price / 100);
        var image = imgURL2( items[i].image, 'medium');
        jsonObj.extra_properties['product_image_' + i]= image;
      }    
      console.log(jsonObj);
      attachklaviyo(jsonObj);
      $('input[name="discount"]').val('FAB5');  
    });
}

// alternatively, if you don't want to use a polyfil
function imgURL2(src, size) {
    var src = src;
    // remove any current image size then add the new image size
    return src
        .replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|master)+\./g, '.')
        .replace(/\.jpg|\.png|\.gif|\.jpeg/g, function(match) {
            return '_' + size + match;
        });
}

Number.prototype.toFixedDown = function(digits) {
    var re = new RegExp("(\\d+\\.\\d{" + digits + "})(\\d)"),
        m = this.toString().match(re);
    return m ? parseFloat(m[1]) : this.valueOf();
};

